import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { Pagination } from '../../../../../../models/pagination-table.model';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { BaryRightService } from '../../../../../../services/bary-right.service';
import { RightEnum } from '../../../../../../models/enums/right.enum';
import { ModeratorTabDto } from '../../../../../../models/moderator-tab-dto';

@Component({
  selector: 'jhi-moderators-list',
  templateUrl: './moderators-list.component.html',
})
export class ModeratorsListComponent {
  @Input() users: ModeratorTabDto[] = [];
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();
  public PATHS = PATHS;
  public WRITE_REFUND = RightEnum.WRITE_REFUND;

  constructor(public baryRightService: BaryRightService) {}

  public changeRight(user: ModeratorTabDto): void {
    if (user.id != null) {
      this.baryRightService.customerIdsChangeRight.has(user.id)
        ? this.baryRightService.customerIdsChangeRight.delete(user.id)
        : this.baryRightService.customerIdsChangeRight.add(user.id);
    }
  }
}
